const modalStore = {
  namespaced: true,
  state: () => ({
    isGlobalLoading: false,
    showModalLevel1: false,
    showRequestNewVendor: false,
    showNewVendor: false,
    showLegalDoc: false,
    showSio: false,
    showK3l: false,
    showKplh: false,
    showModalEmail: false,
    showModalEmailPo: false,
    modalChangeLogo: false,
    addEditPic: false,

    spmEmail: null,
    poEmail: null,
    showSpmEmailPreview: false,
    showPoEmailPreview: false,
    showNewVendorEmail: false,
    emailRequest: '',
    dataRequest: null,
    showIujp: false,
    showIujptl: false,
    showInubbm: false,
    showSbujk: false,
    showDirektur: false,
    showKomisaris: false,
    showPemilikSaham: false,
    showPic: false,
    showIdentity: false,
    showKbliEdit: false,
    profile: null,
  }),
  mutations: {
    SET_MODAL_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    SET_GLOBAL_LOADING(state, status) {
      state.isGlobalLoading = status
    },
    SET_MODAL_LEVEL1(state, status) {
      state.showModalLevel1 = status
    },
    SHOW_LEGAL_DOC(state) {
      state.showLegalDoc = true
    },
    CLOSE_LEGAL_DOC(state) {
      state.showLegalDoc = false
    },
    SHOW_SIO(state) {
      state.showSio = true
    },
    CLOSE_SIO(state) {
      state.showSio = false
    },
    SHOW_K3L(state) {
      state.showK3l = true
    },
    CLOSE_K3L(state) {
      state.showK3l = false
    },
    SHOW_KPLH(state) {
      state.showKplh = true
    },
    CLOSE_KPLH(state) {
      state.showKplh = false
    },
    SHOW_NEW_VENDOR_EMAIL(state) {
      state.showNewVendorEmail = true
    },
    CLOSE_NEW_VENDOR_EMAIL(state) {
      state.showNewVendorEmail = false
    },
    SHOW_NEW_VENDOR(state) {
      state.showNewVendor = true
    },
    CLOSE_NEW_VENDOR(state) {
      state.showNewVendor = false
    },
    SET_DATA_EMAIL(state, spm) {
      state.showModalEmail = true
      state.spmEmail = spm
    },
    EMAIL_MODAL_CLOSE(state) {
      state.showModalEmail = false
    },
    SEND_VENDOR_REQUEST_EMAIL(state) {
      state.showNewVendorEmail = false
      state.showNewVendor = false
    },
    SET_IUJP_MODAL(state, status) {
      state.showIujp = status
    },
    SET_IUJPTL_MODAL(state, status) {
      state.showIujptl = status
    },
    SET_INUBBM_MODAL(state, status) {
      state.showInubbm = status
    },
    SET_SBUJK_MODAL(state, status) {
      state.showSbujk = status
    },
    SET_DIREKTUR_MODAL(state, status) {
      state.showDirektur = status
    },
    SET_KOMISARIS_MODAL(state, status) {
      state.showKomisaris = status
    },
    SET_SAHAM_MODAL(state, status) {
      state.showPemilikSaham = status
    },
    SET_PIC_MODAL(state, status) {
      state.showPic = status
    },
    SET_IDENTITY_MODAL(state, status) {
      state.showIdentity = status
    },
    SPM_EMAIL_PREVIEW(state, status) {
      if (status == 'close') {
        state.showSpmEmailPreview = false
      } else {
        state.showSpmEmailPreview = !state.showSpmEmailPreview
      }
    },
    PO_EMAIL_PREVIEW(state, status) {
      if (status == 'close') {
        state.showPoEmailPreview = false
      } else {
        state.showPoEmailPreview = true
      }
    },
    KBLI_EDIT_MODAL(state, status) {
      state.showKbliEdit = status
    },
    SET_PROFILE_DATA(state, data) {
      state.profile = data
      state.showModalLevel1 = true
    },
    SET_DATA_EMAIL_PO(state, data) {
      state.poEmail = data
      state.showModalEmailPo = true
    },
    SET_MODAL_EMAIL_PO_CLOSE(state) {
      state.showModalEmailPo = false
    },
    SET_REQ_NEW_VENDOR_MODAL(state, status) {
      state.showRequestNewVendor = status
    },
    SET_MODAL_STATE(state, data) {
      state[data.name] = data.value
    },
  },
  actions: {},
}

export default modalStore
